var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5C13.785 0.5 16.4559 1.60633 18.4252 3.5756C20.3944 5.54487 21.5008 8.21578 21.5008 11.0007C21.5008 13.7857 20.3944 16.4566 18.4252 18.4259C16.4559 20.3952 13.785 21.5015 11 21.5015C8.21505 21.5015 5.54414 20.3952 3.57487 18.4259C1.60559 16.4566 0.499268 13.7857 0.499268 11.0007C0.499268 8.21578 1.60559 5.54487 3.57487 3.5756C5.54414 1.60633 8.21505 0.5 11 0.5ZM12.575 6.947C13.355 6.947 13.988 6.4055 13.988 5.603C13.988 4.8005 13.3535 4.259 12.575 4.259C11.795 4.259 11.165 4.8005 11.165 5.603C11.165 6.4055 11.795 6.947 12.575 6.947ZM12.8495 15.3875C12.8495 15.227 12.905 14.81 12.8735 14.573L11.6405 15.992C11.3855 16.2605 11.066 16.4465 10.916 16.397C10.848 16.372 10.7911 16.3235 10.7556 16.2602C10.7201 16.197 10.7084 16.1231 10.7225 16.052L12.7775 9.56C12.9455 8.7365 12.4835 7.985 11.504 7.889C10.4705 7.889 8.94952 8.9375 8.02402 10.268C8.02402 10.427 7.99402 10.823 8.02552 11.06L9.25702 9.6395C9.51202 9.374 9.80902 9.1865 9.95902 9.2375C10.0329 9.26402 10.0935 9.31847 10.1277 9.38914C10.1619 9.45981 10.167 9.54108 10.142 9.6155L8.10502 16.076C7.86952 16.832 8.31502 17.573 9.39502 17.741C10.985 17.741 11.924 16.718 12.851 15.3875H12.8495Z",
    fill: "#17282F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.08aceded8b0601adb37e84bd1d39d5ae.svg";
export { ForwardRef as ReactComponent };